// extracted by mini-css-extract-plugin
module.exports = {"post-comment-replies":"PostCommentWithReplies_post-comment-replies__vBwTE"};